import { render, staticRenderFns } from "./explain-section-layout.component.vue?vue&type=template&id=3a6a394c&scoped=true"
import script from "./explain-section-layout.component.vue?vue&type=script&lang=ts"
export * from "./explain-section-layout.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-section-layout.component.vue?vue&type=style&index=0&id=3a6a394c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a394c",
  null
  
)

export default component.exports